import { Paper } from '@material-ui/core';
import styled from 'styled-components';

export const WrapperTable = styled(Paper)`
  padding: 1rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
  max-height: ${(props) => props.height ?? '100%'};

  .MuiTableContainer-root {
    max-height: ${(props) => props.height ?? '100%'};
    overflow: auto;

    /* Scrollbar */
    ::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }

    ::-webkit-scrollbar-thumb {
      background-color: rgba(0, 0, 0, 0.2);
      border-radius: 4px;
    }

    ::-webkit-scrollbar-track {
      background-color: #eaeaea;
    }
  }

  > nav.MuiPagination-root {
    align-self: flex-end;

    margin-top: 1.5rem;
  }

  .MuiTable-root {
    border-collapse: collapse;
  }

  .MuiTableRow-root {
    height: 30px;
  }

  .MuiTableCell-root {
    padding: 0 8px 0 8px; /* top right bottom left */
    border: 1px solid #ccc;
    text-align: right;
  }

  .MuiTableHead-root .MuiTableCell-root {
    background: #dfe1e5;
    font-weight: bold;
    text-align: center;
  }

  .FarolCell {
    text-align: center;
    height: 60;
  }

  .PostoCell {
    text-align: left;
  }

  .row-gray {
    background-color: #dfe1e5;
  }

  .cell-danger {
    background-color: #ff7452;
    color: #fff;
  }

  .cell-success {
    background-color: #57d9a3;
    color: #fff;
  }
`;
